import { DEFAULT_LOCALE } from '@rover/constants/src/i18n/locale';
import inject from '@rover/utilities/injector';

import getLocalizedFormatContextless from './getLocalizedFormatContextless';

const userLocale = inject('Rover.context.language', DEFAULT_LOCALE);

const getLocalizedFormatInjected = (format: string, locale: string = userLocale): string =>
  getLocalizedFormatContextless(format, locale);

export default getLocalizedFormatInjected;
